export default __webpack_public_path__ + "static/media/logo.0d1ca1a2.png";